import { faPlusCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { renderFormulaList } from "../../actions/formulaAction";
import {
  clearUnfinalizedPrescription,
  practitonerPrescriptionPostAction,
  prescriptionPageTabShowItemList,
  setUnfinalizedPrescriptionId,
} from "../../actions/prescriptionAction";
import { getUserDetail } from "../../utils/helper";
const PendingPrescriptionWarningPopup = ({
  closePopup,
  prescriptionId,
  setActiveSection,
  clearPrescriptionValue,
}) => {
  const dispatch = useDispatch();
  const cancelPrescription = () => {
    const data = {
      action: "cancelPrescription",
      prescription_id: prescriptionId,
      token: getUserDetail()?.token,
    };
    var params = {
      params: data,
    };
    dispatch(practitonerPrescriptionPostAction(params));
  };
  return (
    <Modal size="lg" show={true} id="prescription-popup">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon
                icon={faTimesCircle}
                onClick={() => {
                  closePopup();
                }}
              />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">PENDING PRESCRIPTION</h2>
                  <p className="desc">
                    There is a pending prescription for this patient. Would you
                    like to continue where you left off or cancel and start a
                    new prescription?
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end align-items-center mb-3">
            <button
              className="btn-orange"
              onClick={() => {
                cancelPrescription();
                dispatch(clearUnfinalizedPrescription());
                dispatch(setUnfinalizedPrescriptionId(0));
                clearPrescriptionValue();
                dispatch(renderFormulaList(true));
                dispatch(prescriptionPageTabShowItemList([1, 3]));
                setActiveSection(2);
                closePopup();
              }}
            >
              <FontAwesomeIcon icon={faPlusCircle} /> CANCEL EXISTING AND CREATE
              NEW
            </button>
            <button
              className="btn-orange"
              onClick={() => {
                dispatch(prescriptionPageTabShowItemList([1, 3]));
                dispatch(clearUnfinalizedPrescription());
                dispatch(setUnfinalizedPrescriptionId(prescriptionId));
                clearPrescriptionValue();
                dispatch(renderFormulaList(true));
                setActiveSection(2);
                closePopup();
              }}
            >
              Continue
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default PendingPrescriptionWarningPopup;
